import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import SegMainTable from "../components/SEG-MAIN/segMain";
import Otis from "../components/OTIS/Otis";

const Layout = React.lazy(() => import("./layout"));
const PageLoader = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="h-9 w-9 rounded-full border-4 border-gray-200 border-t-[#e31c23] animate-spin" />
  </div>
);

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    // loader:,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <PageLoader />
                }
              >
                <SegMainTable />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "/details/:segId?/:season?",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <PageLoader />
                }
              >
                <Otis />
              </Suspense>
            }
          />
        ),
      },
      // {
      //   path: "/login",
      //   element: (
      //     <Suspense
      //       fallback={
      //         <Loading
      //           isLoading={true}
      //           height={80}
      //           width={80}
      //           color="#15223F"
      //         ></Loading>
      //       }
      //     >
      //       <AdminLogin />
      //     </Suspense>
      //   ),
      // },
    ],
  },
 
]);